import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n";
import { AuthProvider, AuthCallback, ProtectedRoute } from "@/auth";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import MonCompte from "@/pages/MonCompte";
import PaymentStatus from "@/pages/PaymentStatus";
import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  // OAuth returns with #session_id=... on any route — handle it first.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/mon-compte" element={<ProtectedRoute><MonCompte /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="/payment/success" element={<PaymentStatus />} />
      <Route path="/payment/cancel" element={<PaymentStatus cancelled />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <div className="App relative">
        <div className="grain-overlay" />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0F1115",
              border: "1px solid rgba(0,229,255,0.25)",
              color: "#F3F4F6",
            },
          }}
        />
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}

export default App;
